"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FuturesBalancesAssetsTableContainer = void 0;
var _reactRedux = require("react-redux");
var _reselect = require("reselect");
var _FuturesBalancesAssetsTable = require("./FuturesBalancesAssetsTable");
var _selectors = require("../../../redux/futures/selectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var filteredProductsSelector = (0, _reselect.createSelector)(_selectors.futuresProductSelector, function (_, _ref) {
  var searchText = _ref.searchText;
  return searchText;
}, function (products, searchText) {
  return products.filter(function (p) {
    if (p.isFuturesProductEnabled === false) {
      return false;
    }
    var product = (p === null || p === void 0 ? void 0 : p.ProductSymbol) || '';
    var productFullName = (p === null || p === void 0 ? void 0 : p.ProductFullName) || '';
    return product.toUpperCase().includes(searchText.toUpperCase()) || productFullName.toUpperCase().includes(searchText.toUpperCase());
  });
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loading: (0, _selectors.futuresBalancesLoadingSelector)(state),
    products: filteredProductsSelector(state, ownProps) || [],
    baseAsset: (0, _productsSelectors.baseNotionalProductSymbolSelector)(state)
  };
};
var FuturesBalancesAssetsTableContainer = exports.FuturesBalancesAssetsTableContainer = (0, _reactRedux.connect)(mapStateToProps)(_FuturesBalancesAssetsTable.FuturesBalancesAssetsTable);